import { render, staticRenderFns } from "./use-userCard.vue?vue&type=template&id=b5a39a76&scoped=true"
import script from "./use-userCard.vue?vue&type=script&lang=ts"
export * from "./use-userCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a39a76",
  null
  
)

export default component.exports